module.exports = __webpack_public_path__ + "static/media/plane-load.42fb29d4.gif";